
import { useState } from 'react';

export default function ReservationsPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    guests: '2',
    location: 'ciampino',
    specialRequests: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d41r71cqnjlrn9cd7qo0', {
        method: 'POST',
        body: new URLSearchParams(formDataToSend as any)
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          date: '',
          time: '',
          guests: '2',
          location: 'ciampino',
          specialRequests: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const timeSlots = [
    '12:00', '12:30', '13:00', '13:30', '14:00', '14:30',
    '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00'
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div 
        className="relative h-96 bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/de1cbf97b0f415fb8a7953bbb119b49d.jpg')`
        }}
      >
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white">
            <h1 className="text-5xl font-bold mb-4">Prenota il Tuo Tavolo</h1>
            <p className="text-xl">Vivi un'esperienza culinaria indimenticabile</p>
          </div>
        </div>
      </div>

      {/* Reservation Form Section */}
      <div className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Prenotazione Online</h2>
            <p className="text-lg text-gray-600">
              Prenota facilmente il tuo tavolo presso una delle nostre sedi. 
              Ti confermeremo la prenotazione entro 24 ore.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-xl p-8 border border-gray-100">
            <form id="reservation-form" onSubmit={handleSubmit} data-readdy-form>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Nome */}
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    Nome Completo *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="Il tuo nome completo"
                  />
                </div>

                {/* Email */}
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="la-tua-email@esempio.com"
                  />
                </div>

                {/* Telefono */}
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    Telefono *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="+39 123 456 7890"
                  />
                </div>

                {/* Numero Ospiti */}
                <div>
                  <label htmlFor="guests" className="block text-sm font-medium text-gray-700 mb-2">
                    Numero Ospiti *
                  </label>
                  <select
                    id="guests"
                    name="guests"
                    value={formData.guests}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm pr-8"
                  >
                    {[1,2,3,4,5,6,7,8,9,10].map(num => (
                      <option key={num} value={num.toString()}>
                        {num} {num === 1 ? 'persona' : 'persone'}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Data */}
                <div>
                  <label htmlFor="date" className="block text-sm font-medium text-gray-700 mb-2">
                    Data *
                  </label>
                  <input
                    type="date"
                    id="date"
                    name="date"
                    value={formData.date}
                    onChange={handleInputChange}
                    required
                    min={new Date().toISOString().split('T')[0]}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                  />
                </div>

                {/* Orario */}
                <div>
                  <label htmlFor="time" className="block text-sm font-medium text-gray-700 mb-2">
                    Orario *
                  </label>
                  <select
                    id="time"
                    name="time"
                    value={formData.time}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm pr-8"
                  >
                    <option value="">Seleziona orario</option>
                    {timeSlots.map(time => (
                      <option key={time} value={time}>{time}</option>
                    ))}
                  </select>
                </div>

                {/* Sede */}
                <div className="md:col-span-2">
                  <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-2">
                    Sede *
                  </label>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <label className="flex items-center p-4 border border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50">
                      <input
                        type="radio"
                        name="location"
                        value="ciampino"
                        checked={formData.location === 'ciampino'}
                        onChange={handleInputChange}
                        className="mr-3 text-red-600"
                      />
                      <div>
                        <div className="font-medium">Ciampino - Sede Storica</div>
                        <div className="text-sm text-gray-600">Piazza Trento e Trieste 3</div>
                      </div>
                    </label>
                    <label className="flex items-center p-4 border border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50">
                      <input
                        type="radio"
                        name="location"
                        value="ariccia"
                        checked={formData.location === 'ariccia'}
                        onChange={handleInputChange}
                        className="mr-3 text-red-600"
                      />
                      <div>
                        <div className="font-medium">Ariccia - Nuova Sede</div>
                        <div className="text-sm text-gray-600">Viale Antonietta Chigi 16</div>
                      </div>
                    </label>
                  </div>
                </div>

                {/* Richieste Speciali */}
                <div className="md:col-span-2">
                  <label htmlFor="specialRequests" className="block text-sm font-medium text-gray-700 mb-2">
                    Richieste Speciali
                  </label>
                  <textarea
                    id="specialRequests"
                    name="specialRequests"
                    value={formData.specialRequests}
                    onChange={handleInputChange}
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm resize-none"
                    placeholder="Allergie, intolleranze, occasioni speciali, richieste particolari..."
                  />
                  <div className="text-xs text-gray-500 mt-1">
                    {formData.specialRequests.length}/500 caratteri
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="mt-8">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-red-600 text-white py-4 px-6 rounded-lg font-semibold text-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {isSubmitting ? 'Invio in corso...' : 'Prenota Tavolo'}
                </button>
              </div>

              {/* Status Messages */}
              {submitStatus === 'success' && (
                <div className="mt-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                  <div className="flex items-center">
                    <i className="ri-check-circle-fill mr-2"></i>
                    Prenotazione inviata con successo! Ti contatteremo entro 24 ore per confermare.
                  </div>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="mt-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                  <div className="flex items-center">
                    <i className="ri-error-warning-fill mr-2"></i>
                    Errore nell'invio della prenotazione. Riprova o contattaci direttamente.
                  </div>
                </div>
              )}
            </form>
          </div>

          {/* Contact Info */}
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold text-gray-800 mb-4">Ciampino - Sede Storica</h3>
              <div className="space-y-2 text-gray-600">
                <div className="flex items-center">
                  <i className="ri-map-pin-line mr-2 text-red-600"></i>
                  Piazza Trento e Trieste 3, 00043 Ciampino (RM)
                </div>
                <div className="flex items-center">
                  <i className="ri-phone-line mr-2 text-red-600"></i>
                  +39 06 45763624
                </div>
                <div className="flex items-center">
                  <i className="ri-time-line mr-2 text-red-600"></i>
                  Chiuso Lunedì | Mar-Gio: 15:30-00:00 | Ven-Dom: 11:00-00:00
                </div>
              </div>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold text-gray-800 mb-4">Ariccia - Nuova Sede</h3>
              <div className="space-y-2 text-gray-600">
                <div className="flex items-center">
                  <i className="ri-map-pin-line mr-2 text-red-600"></i>
                  Viale Antonietta Chigi 16, 00072 Ariccia (RM)
                </div>
                <div className="flex items-center">
                  <i className="ri-phone-line mr-2 text-red-600"></i>
                  +39 06 45769762
                </div>
                <div className="flex items-center">
                  <i className="ri-time-line mr-2 text-red-600"></i>
                  Chiuso Lunedì | Mar-Dom: 11:00-00:00
                </div>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-12 bg-yellow-50 border border-yellow-200 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-yellow-800 mb-2">
              <i className="ri-information-line mr-2"></i>
              Informazioni Importanti
            </h3>
            <ul className="text-yellow-700 space-y-1 text-sm">
              <li>• Le prenotazioni vengono confermate entro 24 ore</li>
              <li>• Per gruppi superiori a 10 persone, contattaci direttamente</li>
              <li>• In caso di ritardo superiore a 15 minuti, il tavolo potrebbe essere assegnato ad altri ospiti</li>
              <li>• Per cancellazioni, ti preghiamo di avvisare almeno 2 ore prima</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
